<script lang="ts">
	import { format } from 'svelte-i18n';
	import {
		get_gen_2_component_channel_structure,
		real_id,
	} from '../../../../helpers/interface_helpers';
	import {
		getDeviceSettings,
		readDeviceSettings,
	} from 'src/stores/device-runtime/status-selectors';
	import type { Device } from '../../../../types/Device';
	import SettingGuide from '../../SettingGuide.svelte';
	import UnderVoltageG2 from './UnderVoltageG2.svelte';
	import OverUnderVoltageAutoRecovery from './OverUnderVoltageAutoRecovery.svelte';

	export let device: Device;

	const id = real_id(device.id);
	$: settingsStore = getDeviceSettings(id);
	let settings = readDeviceSettings(id);
	$: settings = $settingsStore ?? settings;

	$: channelSettings = settings?.[get_gen_2_component_channel_structure(device)];
	$: showUndervoltage = channelSettings?.undervoltage_limit !== undefined;
	$: showRecovery = channelSettings?.autorecover_voltage_errors !== undefined;
</script>

<SettingGuide
	text={$format('settings_guide_voltage_protection', {
		default:
			'Set a minimum voltage to turn the output off, and choose whether it comes back on by itself once voltage is normal.',
	})}
/>

{#if showUndervoltage}
	<div class="mb-m">
		<UnderVoltageG2 {device} hideGuide />
	</div>
{/if}

{#if showRecovery}
	<OverUnderVoltageAutoRecovery {device} hideGuide />
{/if}
